import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UiStateStore } from 'src/app/shared/store/ui-state-store.service';
import { JobSummary } from '../../models/job-summary';
import { JobsStore } from '../../store/jobs-store.service';

@Component({
  selector: 'list-jobs',
  templateUrl: './list-jobs.component.html',
  styleUrls: ['./list-jobs.component.scss']
})

export class ListJobsComponent implements OnInit {
  @Input() jobs: JobSummary[] = [];
  @Input() totalPageCount: Observable<number>;
  @Input() title: string;
  @Input() showPager: boolean = true;
  @Output() pageNumberClicked = new EventEmitter<number>();

  currentRoute: string;

  constructor(private uiStore: UiStateStore, private jobStore: JobsStore, private router: Router, private route: ActivatedRoute) {
    this.currentRoute = this.route.snapshot.url[0].path;
  }

  ngOnInit() {
  }

  onPagerValueChanged(event): void {
    this.pageNumberClicked.emit(event.number);
  }

  onJobTitleClicked(jobId: string): void {
    this.router.navigate([`/view-job`, this.currentRoute]);
    this.uiStore.setSelectedJobId(jobId);
  }

  onFavouriteClicked(jobId: string): void {
    let foundJob = this.jobs.find(job => job.id == jobId);
    if (!foundJob) {
      throw new Error(`Job not found for Id ${jobId}`);
    }

    foundJob.bookmarked = !foundJob.bookmarked;
    if (foundJob.bookmarked) {
      this.jobStore.bookmarkJobInLocalStore(foundJob.id);
    } else {
      this.jobStore.unBookmarkJobInLocalStore(foundJob.id);
    }
  }

  onViewJobClicked(job: JobSummary): void {
    if (this.title == this.jobStore.SAVED_JOB_TITLE) {
      window.open(`/view-job/${job.id}/${this.currentRoute}`);
    } else {
      window.open(`/view-job-interest/${job.id}/${job.postedBy}`);
    }

  }

}
